import { Outlet } from "react-router-dom";
import { NavSidebar } from "@/components/NavBarRework/components/app-sidebar";
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "@/components/ui/sidebar";
import { ColoredTop } from "../misc";

// Preserves Bar State (so if you collapsed it, it will stay that way)
function getSidebarDefaultOpen(): boolean {
	const cookie = document.cookie
		.split("; ")
		.find((row) => row.startsWith("sidebar_state="));
	return cookie ? cookie.split("=")[1] === "true" : true;
}

// This just frames the whole page.
// So the Nav Bar is on the left and everything else on the right.
export default function NavBarRework() {
	return (
		<SidebarProvider defaultOpen={getSidebarDefaultOpen()}>
			<NavSidebar />

			<SidebarInset className="flex-grow overflow-hidden">
				<SidebarTrigger className="m-2 fixed" />
				<ColoredTop />
				<Outlet />
			</SidebarInset>
		</SidebarProvider>
	);
}
